import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DynamicFormValueService } from '@shared/components/dynamic-form-value/dynamic-form-value.service';
import { CommonsService } from '@core/service/commons.service';
import { DynamicFormService } from '../../../routes/dev-tools/dynamic-form/dynamic-form.service';

/**
 * 附件组件
 */
@Component({
  selector: 'dynamic-form-value',
  templateUrl: './dynamic-form-value.component.html',
})
export class DynamicFormValueComponent implements OnInit {


  /**
   * 是否编辑
   */
  @Input() isEdit: boolean;
  /**
   *动态表单代码（指明表单类型）
   */
  @Input() dynamicFormCode: string;
  /**
   * 业务对象那类型
   */
  @Input() bizType: string;
  /**
   * 业务对象Id
   */
  @Input() bizId: string;

  //是否可切换编辑状态
  @Input() isSwitchState;

  @ViewChild('dynamicForm') dynamicForm: NgForm;

  configData: any = {};
  singleLineTables = [];
  multipleLineTables = [];

  valueData: any = {data: {}};

  constructor(private dynamicFormService: DynamicFormService, private dynamicFormValueService: DynamicFormValueService, private commonsService: CommonsService) {

  }
  //点击编辑按钮切换为编辑状态
  edit(){
    this.isEdit = true;
  }

  //点击查看按钮切换为查看状态
  public tabsetIndex = 0;
  view(){
    this.tabsetIndex = 0;
    this.ngOnInit();
    this.isEdit = false;
  }

  //数组排序
  compare(property) {
    return function (a, b) {
      let value1 = a[property];
      let value2 = b[property];
      return value1 - value2;
    }
  }

  tableObjInit(){
    this.tableObj.dynamicFields.forEach(field =>{
      if(field.inputType == 'LONG_TEXT' || field.inputType == 'ATTACHMENT'){
        if(!this.editTableFields[field.fieldName]){
          this.editTableFields[field.fieldName] = {};
        }
      }
    });
  }

  ngOnInit() {
    this.loading = true;
    this.dynamicFormService.getByCode(this.dynamicFormCode).subscribe(configData => {
      this.loading = false;
      this.configData = configData;
      this.singleLineTables = this.configData.dynamicTables.filter(item => item.dataType == 'Single');
      this.multipleLineTables = this.configData.dynamicTables.filter(item => item.dataType == 'Multiple');
      if (this.multipleLineTables.length) {
        this.multipleLineTables.sort(this.compare('orderNumber'));
        this.tableObj = this.multipleLineTables[0];
        this.tableObjInit();
      }
      this.initData();
      this.loading = true;
      this.dynamicFormValueService.getByCodeAndBizTypeAndBizId(this.dynamicFormCode, this.bizType, this.bizId).subscribe(valueData => {
        this.valueData = valueData;
        this.initData();
        this.loading = false;
      }, () => {
        this.valueData = {
          dynamicFormId: this.configData.id,
          bizType: this.bizType,
          bizId: this.bizId,
          data: {},
        };
        this.initData();
        this.loading = false;
      },() => this.loading = false);
    },() => this.loading = false,() => this.loading = false);
  }


  initData(): any {
    this.configData.dynamicTables.forEach(table => {
      if (!this.valueData) {
        this.valueData = {
          dynamicFormId: this.configData.id,
          bizType: this.bizType,
          bizId: this.bizId,
          data: {},
        };
      }
      if (!this.valueData.data) {
        this.valueData.data = {};
      }
      if (!this.valueData.data[table.tableName]) {
        if (table.dataType == 'Single') {
          this.valueData.data[table.tableName] = {};
          table.dynamicFields.forEach(field =>{
            if(field.inputType == 'LONG_TEXT' || field.inputType == 'ATTACHMENT'){
              if(!this.valueData.data[table.tableName][field.fieldName]){
                this.valueData.data[table.tableName][field.fieldName] = {};
              }
            }
          });
        } else if (table.dataType == 'Multiple') {
          this.valueData.data[table.tableName] = [];
        }
      }else{
        if(table.dataType == 'Single'){
          table.dynamicFields.forEach(field =>{
            if(field.inputType == 'LONG_TEXT' || field.inputType == 'ATTACHMENT'){
              if(!this.valueData.data[table.tableName][field.fieldName]){
                this.valueData.data[table.tableName][field.fieldName] = {};
              }
            }
          });
        }else if (table.dataType == 'Multiple'){
          table.dynamicFields.forEach(field =>{
            if(field.inputType == 'LONG_TEXT' || field.inputType == 'ATTACHMENT'){
              for(let i=0;i<this.valueData.data[table.tableName].length;i++){
                if(!this.valueData.data[table.tableName][i][field.fieldName]){
                  this.valueData.data[table.tableName][i][field.fieldName] = {};
                }
              }
            }
          });
        }
      }
    });
  }

  public validateForm(): boolean {
    for (let item in this.dynamicForm.controls) {
      this.dynamicForm.controls[item].markAsDirty();
      this.dynamicForm.controls[item].updateValueAndValidity();
    }
    if (this.dynamicForm.valid) {
      return true;
    }
    return false;
  }


//  表格
  allChecked = false;
  indeterminate = false;
  displayData = [];
  public selectDatas: any = [];

  currentPageDataChange($event: Array<{ name: string; age: number; address: string; checked: boolean; disabled: boolean; }>): void {
    this.displayData = $event;
    this.refreshStatus();
  }

  refreshStatus(): void {
    const allChecked = this.displayData.filter(value => !value.disabled).every(value => value.checked === true);
    const allUnChecked = this.displayData.filter(value => !value.disabled).every(value => !value.checked);
    this.allChecked = allChecked;
    this.indeterminate = (!allChecked) && (!allUnChecked);
    this.selectDatas = this.displayData.filter(value => value.checked);
  }

  checkAll(value: boolean): void {
    this.displayData.forEach(data => {
      data.checked = value;
    });
    this.refreshStatus();
  }

  public tableObj: any = {};

  selectTableObj(tableItem) {
    setTimeout(() => {
      this.tableObj = tableItem;
      this.tableObjInit();
    }, 0);
  }

//  弹框
  @ViewChild('tableForm') tableForm: NgForm;
  public modalIsVisible: any = false;
  public editTableFields: any = {};
  public editeIndex: any = -1;

  editTableField(fields?, i?) {
    this.modalIsVisible = true;
    if (fields) {
      this.editTableFields = JSON.parse(JSON.stringify(fields));
      this.editeIndex = i;
    } else {
      this.editTableFields = {};
      this.editeIndex = -1;
    }
    this.tableObjInit();
  }

  deleteTableField() {
    let arr = [];
    for (let i = 0; i < this.valueData.data[this.tableObj.tableName].length; i++) {
      if (!this.valueData.data[this.tableObj.tableName][i].checked) {
        arr.push(this.valueData.data[this.tableObj.tableName][i]);
      }
    }
    setTimeout(() => {
      this.valueData.data[this.tableObj.tableName] = arr;
      this.selectDatas = [];
    }, 0);
  }

  handleCancel() {
    this.modalIsVisible = false;
  }

  handleOk() {
    for (let item in this.tableForm.controls) {
      this.tableForm.controls[item].markAsDirty();
      this.tableForm.controls[item].updateValueAndValidity();
    }
    if (!this.tableForm.valid) {
      return;
    }
    this.modalIsVisible = false;
    if (this.editeIndex == -1) {
      let arr = JSON.parse(JSON.stringify(this.valueData.data[this.tableObj.tableName]));
      arr.push(this.editTableFields);
      this.valueData.data[this.tableObj.tableName] = JSON.parse(JSON.stringify(arr));
    } else {
      let arr = JSON.parse(JSON.stringify(this.valueData.data[this.tableObj.tableName]));
      arr[this.editeIndex] = this.editTableFields;
      this.valueData.data[this.tableObj.tableName] = JSON.parse(JSON.stringify(arr));
    }
  }

  public loading:boolean = false;
//  保存
  saveFields() {
    for (let item in this.dynamicForm.controls) {
      this.dynamicForm.controls[item].markAsDirty();
      this.dynamicForm.controls[item].updateValueAndValidity();
    }
    if (!this.dynamicForm.valid) {
      return;
    }
    this.loading = true;
    this.dynamicFormValueService.update(this.valueData).subscribe((data) => {
      this.loading = false;
      this.commonsService.showSuccessMessage("commons.info.saveSucceed");
    },() => this.loading = false,() => this.loading = false);
  }
}
